import { apiBaseUrl } from 'app/src/msw/shopping/api/apiBaseUrl'
import { getAllOrders } from 'app/src/msw/shopping/initialSeed/orders'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getOrder = http.get<{ orderId: string }, object, shoppingApi.OrderDetails>(
  apiBaseUrl + '/orders/:orderId',
  async ({ params }) => {
    await new Promise((resolve) => setTimeout(resolve, 1000))

    const order: shoppingApi.OrderDetails = (await getAllOrders()).find((order) => order.orderId === params.orderId)!

    return HttpResponse.json(order)
  },
)
